import React from 'react'

export const IconClock = () => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.264 8.50016C15.264 12.1802 12.2773 15.1668 8.59733 15.1668C4.91733 15.1668 1.93066 12.1802 1.93066 8.50016C1.93066 4.82016 4.91733 1.8335 8.59733 1.8335C12.2773 1.8335 15.264 4.82016 15.264 8.50016Z"
        stroke="#FF7012"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0706 10.6202L9.00392 9.38684C8.64392 9.1735 8.35059 8.66017 8.35059 8.24017V5.50684"
        stroke="#FF7012"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
